export default __webpack_public_path__ + "static/media/photo--sm--10.f5050c47.jpg";